import { isApiError } from "../services/api";

function ensureSentence(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) {
    return "";
  }
  return trimmed.endsWith(".") ? trimmed : `${trimmed}.`;
}

export function getErrorAlertMessage(action: string, error: unknown): string {
  if (isApiError(error)) {
    return error.message;
  }
  if (error instanceof Error && error.message) {
    return `We couldn't ${action}. ${ensureSentence(error.message)}`;
  }
  return `We couldn't ${action}. Please try again.`;
}

export type AlertState = {
  type: "info" | "error";
  message: string;
  details?: string[];
};
